import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TipoContratoService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getTiposContratos() {
    return this.http.get(this.myAppUrl + 'api/tipocontrato');
  }

  getTipoContratoByID(id:number) {
    return this.http.get(this.myAppUrl + 'api/tipocontrato/' + id );
  }

  updateTipoContrato(tipoContrato:any) {
    return this.http.put(this.myAppUrl + 'api/tipocontrato/', tipoContrato);
  }

  createTipoContrato(tipoContrato: any) {
    return this.http.post(this.myAppUrl + 'api/tipocontrato/', tipoContrato);
  }
}
